import * as React from "react";
import { useTranslation } from "react-i18next";
import { ConfirmationModal, EmployeeCardOptions } from "src/common/components";
import CancelModal from "src/modules/Dashboard/MyEmployees/components/CancelModal";
import { TalkStatus } from "src/common/types";
import ReassignTalkModal from "./ReassignTalkModal";

const ParticipantActions = (props: any) => {
  const [talkToReassign, updateTalkToReassign] = React.useState<string>("");
  const [talkToCancel, updateCancelTalk] = React.useState<string>("");
  const [talkToReopen, updateReopenTalk] = React.useState<string>("");

  const { t } = useTranslation();

  const handleReassignClick = React.useCallback(() => {
    updateTalkToReassign(props.participant.id);
  }, []);

  const handleReassignClose = React.useCallback(() => {
    updateTalkToReassign("");
  }, []);

  const handleCancelClick = React.useCallback(() => {
    updateCancelTalk(props.participant.id);
  }, []);

  const handleCancelClose = React.useCallback(() => {
    updateCancelTalk("");
  }, []);

  const handleReopenClick = React.useCallback(() => {
    updateReopenTalk(props.participant.id);
  }, []);

  const handleReopenClose = React.useCallback(() => {
    updateReopenTalk("");
  }, []);

  const showOptionCard = !talkToReassign && !talkToReopen && !talkToCancel;

  const handleReassign = (body: any) => {
    props.handleReassign(body);
    props.handleOptionsClose();
  };
  const handleTalkReopen = () => {
    props.handleTalkReopen();
    props.handleOptionsClose();
  };
  const handleTalkCancellation = (body: any) => {
    props.handleTalkCancellation(body);
    props.handleOptionsClose();
  };
  return (
    <>
      <ReassignTalkModal
        participant={props.participant}
        talkToReassign={talkToReassign}
        onClose={handleReassignClose}
        open={Boolean(talkToReassign)}
        onReassign={handleReassign}
      />
      <CancelModal
        onClose={handleCancelClose}
        open={Boolean(talkToCancel)}
        onCancel={handleTalkCancellation}
        cancelReasons={props.cancelReasons}
      />
      <ConfirmationModal
        onConfirm={handleTalkReopen}
        onCancel={handleReopenClose}
        message={t(`feedback.page.my-employees.reopenModal.message`)}
        title={t(`feedback.page.my-employees.reopenModal.title`)}
        openModal={Boolean(talkToReopen)}
      />

      {showOptionCard && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            width: 200,
            zIndex: 2
          }}
        >
          <EmployeeCardOptions
            open={props.optionsOpen}
            onClose={props.handleOptionsClose}
            cycleId={props.cycleId}
            showCancel
            showReasign
            showReopen
            reopenDisabled={props.talkStatus !== TalkStatus.Cancelled}
            reassignDisabled={[TalkStatus.Done, TalkStatus.Cancelled].includes(props.talkStatus)}
            cancelDisabled={[TalkStatus.Done, TalkStatus.Cancelled].includes(props.talkStatus)}
            onReassign={handleReassignClick}
            onCancel={handleCancelClick}
            onReopen={handleReopenClick}
          />
        </div>
      )}
    </>
  );
};

export default ParticipantActions;
